// extracted by mini-css-extract-plugin
export default {"AttempCount":"CampaignCard_AttempCount__QDrEj","CampaignTitle":"CampaignCard_CampaignTitle__Xo9jb"};